module.exports = __webpack_public_path__ + "static/media/bg_benefits_perks_and_compensation.8a763b25.mp4";